<template>
  <div class="result-table">
    <div class="table">
      <div class="table-item" v-if="data.classifyId != 5">
        <div class="title">{{ data.classifyId == 2 ? '报告编号' : '证书编号' }}:</div>
        <div class="value">{{ data.reportNo }}</div>
      </div>
      <div class="table-item" v-if="data.classifyId != 5">
        <div class="title">单位名称:</div>
        <div class="value">{{ data.unitName }}</div>
      </div>
      <div class="table-item" v-if="data.classifyId == 2">
        <div class="title">样品名称:</div>
        <div class="value">{{ data.sampleName }}</div>
      </div>
      <div class="table-item" v-if="data.classifyId == 1">
        <div class="title">器具名称:</div>
        <div class="value">{{ data.utensilName }}</div>
      </div>
      <div class="table-item" v-if="data.classifyId == 1 || data.classifyId == 2">
        <div class="title">型号/规格:</div>
        <div class="value">{{ data.specs }}</div>
      </div>
      <div class="table-item" v-if="data.classifyId == 1">
        <div class="title">出厂编号:</div>
        <div class="value">{{ data.factoryNo }}</div>
      </div>
      <div class="table-item" v-if="data.classifyId == 1">
        <div class="title">管理编号:</div>
        <div class="value">{{ data.manageNo }}</div>
      </div>
      <div class="table-item" v-if="data.classifyId == 1 || data.classifyId == 2">
        <div class="title">制造厂商:</div>
        <div class="value">{{ data.manufacturer }}</div>
      </div>
      <div class="table-item" v-if="data.classifyId == 1 || data.classifyId == 2">
        <div class="title">{{ data.classifyId == 1 ? '校验日期' : '检测日期' }}:</div>
        <div class="value">{{ data.testDate }}</div>
      </div>
      <div class="table-item" v-if="data.classifyId == 1 || data.classifyId == 2">
        <div class="title">{{ data.classifyId == 1 ? '检定结论' : '检测结论' }}:</div>
        <div class="value">
          {{ data.testVerdict }}
        </div>
      </div>
      <div class="table-item" v-if="data.classifyId == 1 || data.classifyId == 2">
        <div class="title">{{ data.classifyId == 1 ? '校验单位' : '检测单位' }}:</div>
        <div class="value">{{ data.testUnit }}</div>
      </div>
      <div class="table-item" v-if="data.classifyId == 3 || data.classifyId == 4">
        <div class="title">发证日期:</div>
        <div class="value">{{ data.proveDate }}</div>
      </div>
      <div class="table-item" v-if="data.classifyId == 3 || data.classifyId == 4">
        <div class="title">发证单位:</div>
        <div class="value">{{ data.proveUnit }}</div>
      </div>
      <div class="table-item" v-if="data.classifyId == 5">
        <div class="title">生产厂家:</div>
        <div class="value">{{ data.produceFactory }}</div>
      </div>
      <div class="table-item" v-if="data.classifyId == 5">
        <div class="title">产品名称:</div>
        <div class="value">{{ data.productName }}</div>
      </div>
      <div class="table-item" v-if="data.classifyId == 5">
        <div class="title">生产日期:</div>
        <div class="value">{{ data.produceDate }}</div>
      </div>
      <div class="table-item" v-if="data.classifyId == 5">
        <div class="title">生产批次:</div>
        <div class="value">{{ data.produceBatch }}</div>
      </div>
      <div class="table-item" v-if="data.classifyId == 5">
        <div class="title">防伪码:</div>
        <div class="value">{{ data.securityCode }}</div>
      </div>
      <div class="table-item" v-if="showOperate">
        <div class="title">操作:</div>
        <div class="value">
          <span>
            <a v-if="data.fileUrl.substring(data.fileUrl.lastIndexOf('.') + 1) == 'pdf'" :href="data.fileUrl"
               target="_blank">文件预览</a>
            <span v-else @click="previewFile">文件预览</span>
          </span>
          <span @click="downloadFile">文件下载</span>
          <span @click="showQrcode = true">二维码</span>
        </div>
      </div>
      <el-image class="sign" :class="from === 'mobile' ? 'mobile' : ''" :src="sign"></el-image>
    </div>
    <!--二维码弹窗-->
    <qrcode-layer :visible.sync="showQrcode" :data="currentQrcodeUrl"/>
    <!--<el-image :src="previewImage" :preview-src-list="[previewImage]" id="previewImgRef" ref="previewImgRef" style="position:fixed;top: -1000px;left:-1000px;"></el-image>-->
  </div>
</template>

<script>
import QrcodeLayer from "./QrcodeLayer.vue";

export default {
  name: "InquiryResultTable",
  components: {
    QrcodeLayer
  },
  props: {
    data: Object,
    showOperate: {
      type: Boolean,
      default: true
    },
    from: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showQrcode: false,
      previewImage: '@/assets/inquiry/loading.png',
      sign: process.env.VUE_APP_API_BASE_URL.substring(0, process.env.VUE_APP_API_BASE_URL.lastIndexOf('/')) + '/static/images/sign.png'
    }
  },
  computed: {
    // 当前二维码地址
    currentQrcodeUrl () {
      const location = window.location;
      let url = location.origin + location.pathname;
      if(url.slice(-1) !== '/') url += '/';
      return `${url}result?inquiryId=${this.data.inquiryId}`;
    }
  },
  methods: {
    /**
     * 预览文件
     */
    previewFile () {
      const fileType = this.data.fileUrl.substring(this.data.fileUrl.lastIndexOf('.') + 1).toLowerCase();
      if (['jpg', 'jpeg', 'png'].indexOf(fileType) > -1) {
        window.open(this.data.fileUrl);
        return false
      }
      if (['docx', 'doc', 'xlsx', 'xls', 'ppt', 'pptx'].indexOf(fileType) === -1) {
        this.$message.error('暂不支持预览')
        return false
      }
      window.open(`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(this.data.fileUrl)}`, '_blank')
    },
    /**
     * 文件下载
     */
    downloadFile () {
      window.open(this.data.fileUrl, '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
.result-table {
  border-top: 1px solid #D7D7D7;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .table {
    width: 840px;
    padding: 30px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    .table-item {
      width: 100%;
      display: flex;
      flex-direction: row;
      border-bottom: 1px solid #D7D7D7;
      font-size: 16px;
      font-weight: bold;
      align-items: stretch;

      &:last-child {
        border-bottom: 0;
      }

      .title {
        width: 124px !important;
        padding: 20px 30px !important;
        background-color: #1464FF;
        color: #FFFFFF;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        white-space: nowrap;
        line-height: 25px;
        font-size: 16px;
      }

      .value {
        flex: 1;
        width: 0;
        padding: 20px 30px !important;
        background-color: #F1F5FF;
        color: #2D2D2D;
        word-break: break-all;
        line-height: 25px;
        font-size: 16px;

        span {
          color: #1464FF;
          font-size: 14px;
          cursor: pointer;
          margin-left: 15px;

          a {
            color: #1464FF;
            text-decoration: none;
          }

          &:first-child {
            margin-left: 0;
          }

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }

    .sign {
      position: absolute;
      left:50%;top:50%;
      transform: translate(-50%, -50%);
      width:200px;
      height:200px;

      &.mobile {
        width:100px;
        height:100px;
        transform: translate(30%, -50%);
      }
    }
  }
}
</style>